export default __webpack_public_path__ + "static/media/Phone.5695c93a.svg";